import type RegisterCredentials from '../models/register-credentials';
import i18n from '../../../i18n';
import { type RegisterResponseAdmin, type RegisterResponseOfficeManager } from '../models/register-response';
import { postRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../keycloak/KeycloakProvider';
import User from '../models/user';
import OfficeManagerUser from '../models/officeManagerUser';

export const registerAdmin = async (credentials: RegisterCredentials, keycloak: KeycloakContext): Promise<RegisterResponseAdmin> => {
  const apiResponse = await postRequest<User>('Authentication/register-admin', keycloak, credentials);

  if (apiResponse.error || apiResponse.json === undefined) {
    if (apiResponse.status === 409) {
      return {
        success: false,
        errorMessage: i18n.t('email-already-used').toString(),
      };
    }

    return {
      success: false,
      errorMessage: i18n.t('registration-error-message').toString(),
    };
  }
  return { user: apiResponse.json, success: true };
};

export const registerOfficeManager = async (
  credentials: RegisterCredentials,
  keycloak: KeycloakContext,
): Promise<RegisterResponseOfficeManager> => {
  const apiResponse = await postRequest<OfficeManagerUser[]>('Authentication/register-officemanager', keycloak, credentials);

  if (apiResponse.error || apiResponse.json === undefined) {
    if (apiResponse.status === 409) {
      return {
        success: false,
        errorMessage: i18n.t('email-already-used').toString(),
      };
    }

    return {
      success: false,
      errorMessage: i18n.t('registration-error-message').toString(),
    };
  }
  return { users: apiResponse.json, success: true };
};
